// src/context/ThemeContext.js
import React, { createContext, useState, useMemo, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const defaultMode = "light"; 

  const [mode, setMode] = useState(() => {
    return localStorage.getItem("themeMode") || defaultMode;
  });

const [customColors, setCustomColors] = useState(() => {
  const savedColors = localStorage.getItem("customColors");
  return savedColors
    ? JSON.parse(savedColors)
    : {
        background: "#f5f5f5",
        cardBg: "#ffffff",
        text: "#111111",
        primary: "#1976d2",
        secondary: "#9c27b0",
        bgProfile: "linear-gradient(to right, #142be1, #44a6e9)",
         bgNav: "#ffffff",
      };
});

  // LocalStorage + body class sync
useEffect(() => {
  localStorage.setItem("themeMode", mode);
  localStorage.setItem("customColors", JSON.stringify(customColors));
  document.body.classList.remove("light-mode", "dark-mode", "custom-mode");
  document.body.classList.add(`${mode}-mode`);

  // Reset body background for non-dark modes
  if (mode === "dark") {
    document.body.style.backgroundColor = "#000000"; // Pure black for dark mode
  } else {
    document.body.style.backgroundColor = ""; // Reset to default (removes inline style)
  }

  if (mode === "custom") {
    document.body.style.setProperty("--custom-bg", customColors.background);
    document.body.style.setProperty("--custom-cardBg", customColors.cardBg);
    document.body.style.setProperty("--custom-text", customColors.text);
    document.body.style.setProperty("--custom-primary", customColors.primary);
    document.body.style.setProperty("--custom-secondary", customColors.secondary);
    document.body.style.setProperty("--custom-editorBg", customColors.bgProfile || "#fafafa");
    document.body.style.setProperty("--custom-navBg", customColors.bgNav || "#ffffff");
    if (customColors.bg) {
      document.body.style.setProperty("--custom-bgAlt", customColors.bg);
      document.body.style.setProperty("--custom-dashboardBg", customColors.dashboardBg || "#f5f5f5");
    }
  }
}, [mode, customColors]);



  // MUI Theme
  const theme = useMemo(() => {
    if (mode === "light") return createTheme({ palette: { mode: "light" } });
   if (mode === "dark") return createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000000",  // Pure black background
      paper: "#121212",    // Darker shade for cards/surfaces
    },
  },
});

    return createTheme({
      palette: {
        mode: "light", // 👈 custom ko light base pe rakha (ya "dark" bhi kar sakte ho)
        primary: { main: customColors.primary },
        secondary: { main: customColors.secondary },
        background: { default: customColors.background },
        text: { primary: customColors.text },
      },
    });
  }, [mode, customColors]);

  return (
    <ThemeContext.Provider value={{ mode, setMode, customColors, setCustomColors }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
